import { render } from 'react-dom';
import App from './pages';

render(
  <App />,
  document.getElementById('root'),
);
